import FaqLibrary from "../components/FaqLibrary";

function FaqsPage() {
  return <FaqLibrary />;
}

export default FaqsPage;
